import React from "react";
import { FormGroup, Label, Input, FormFeedback } from "reactstrap";
import { useField } from "formik";

// App
import { CheckboxProps } from "../../../../types";

const Checkbox: React.FC<CheckboxProps> = ({
  label,
  name,
  isRequired,
  disabled,
  onChange,
}) => {
  const [field, meta] = useField(name);
  const { onChange: fieldOnChange, ...fieldProps } = field;

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Formik default handleChange
    fieldOnChange(e);

    // Custom onChange provided by the parent component
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <FormGroup check className="mb-3">
      <Label check>
        <Input
          type="checkbox"
          {...fieldProps}
          id={name}
          disabled={disabled}
          name={name}
          checked={field.value}
          onChange={handleCheckboxChange}
          invalid={meta?.touched && !!meta?.error}
        />
        {label}
        {isRequired && " *"}
        {meta?.touched && meta?.error && (
          <FormFeedback>{meta?.error}</FormFeedback>
        )}
      </Label>
    </FormGroup>
  );
};

export default Checkbox;
